/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * nhk-api
 * NHK英単語のAPI
 * OpenAPI spec version: 1.0
 */
import { customInstance } from '../mutator/customInstance';
import type {
  GetAdminCount200,
  GetAdminList200,
  GetAdminListParams,
  GetRankingTopParams,
  GetRankingUserId200,
  GetRankingUserIdParams,
  GetUserCountParams,
  PostAdminCount200,
  PostQuestionAnswerBody,
  PostQuestionAnswerParams,
  PostRankingNameBody,
  PostRankingUserId200,
  PostRankingUserIdBody,
  PostRankingUserIdParams,
  PostSurveyAnswerBody,
  UserRank
} from './model'


 
  type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;


  /**
 * ランキングTOPを取得するAPI
 * @summary ランキングTOP取得API
 */
export const getRankingTop = (
    params: GetRankingTopParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<UserRank[]>(
      {url: `/ranking/top`, method: 'get',
        params
    },
      options);
    }
  
/**
 * ランキング順位取得API
 * @summary ランキング順位取得API
 */
export const getRankingUserId = (
    params: GetRankingUserIdParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<GetRankingUserId200>(
      {url: `/ranking`, method: 'get',
        params
    },
      options);
    }
  
/**
 * ランキング得点更新API
 * @summary ランキング得点更新API
 */
export const postRankingUserId = (
    postRankingUserIdBody: PostRankingUserIdBody,
    params: PostRankingUserIdParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PostRankingUserId200>(
      {url: `/ranking`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: postRankingUserIdBody,
        params
    },
      options);
    }
  
/**
 * ランキングリセットAPI
 * @summary ランキングリセットAPI
 */
export const deleteRanking = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/ranking`, method: 'delete'
    },
      options);
    }
  
/**
 * ユーザー名更新API
 * @summary ユーザー名更新API
 */
export const postRankingName = (
    postRankingNameBody: PostRankingNameBody,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/ranking/name`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: postRankingNameBody
    },
      options);
    }
  
/**
 * 現在の解答数取得API
 * @summary 現在解答数取得API
 */
export const getAnswer = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<number>(
      {url: `/question/number`, method: 'get'
    },
      options);
    }
  
/**
 * 解答データ送信API
 * @summary 解答データ送信API
 */
export const postQuestionAnswer = (
    postQuestionAnswerBody: PostQuestionAnswerBody,
    params: PostQuestionAnswerParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/question/answer`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: postQuestionAnswerBody,
        params
    },
      options);
    }
  
/**
 * アンケート解答送信API
 * @summary アンケート解答送信API
 */
export const postSurveyAnswer = (
    postSurveyAnswerBody: PostSurveyAnswerBody,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/survey/answer`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: postSurveyAnswerBody
    },
      options);
    }
  
/**
 * 管理画面用の当日解答数取得API
 * @summary 当日解答数取得API
 */
export const getAdminCount = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<GetAdminCount200>(
      {url: `/admin/count`, method: 'get'
    },
      options);
    }
  
/**
 * 次の日のcountを作成するAPI
 * @summary 翌日分count作成API
 */
export const postAdminCount = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PostAdminCount200>(
      {url: `/admin/count`, method: 'post'
    },
      options);
    }
  
/**
 * 管理画面用の日別解答数一覧取得API
 * @summary 日別解答数一覧取得API
 */
export const getAdminList = (
    params: GetAdminListParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<GetAdminList200>(
      {url: `/admin/list`, method: 'get',
        params
    },
      options);
    }
  
/**
 * 管理画面用CSVダウンロードAPI
 * @summary CSVダウンロードAPI
 */
export const getAdminCsv = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<string[][]>(
      {url: `/admin/csv`, method: 'get'
    },
      options);
    }
  
/**
 * ユーザーの受験回数取得API
 * @summary ユーザー受験回数取得API
 */
export const getUserCount = (
    params: GetUserCountParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<number>(
      {url: `/user/count`, method: 'get',
        params
    },
      options);
    }
  
export type GetRankingTopResult = NonNullable<Awaited<ReturnType<typeof getRankingTop>>>
export type GetRankingUserIdResult = NonNullable<Awaited<ReturnType<typeof getRankingUserId>>>
export type PostRankingUserIdResult = NonNullable<Awaited<ReturnType<typeof postRankingUserId>>>
export type DeleteRankingResult = NonNullable<Awaited<ReturnType<typeof deleteRanking>>>
export type PostRankingNameResult = NonNullable<Awaited<ReturnType<typeof postRankingName>>>
export type GetAnswerResult = NonNullable<Awaited<ReturnType<typeof getAnswer>>>
export type PostQuestionAnswerResult = NonNullable<Awaited<ReturnType<typeof postQuestionAnswer>>>
export type PostSurveyAnswerResult = NonNullable<Awaited<ReturnType<typeof postSurveyAnswer>>>
export type GetAdminCountResult = NonNullable<Awaited<ReturnType<typeof getAdminCount>>>
export type PostAdminCountResult = NonNullable<Awaited<ReturnType<typeof postAdminCount>>>
export type GetAdminListResult = NonNullable<Awaited<ReturnType<typeof getAdminList>>>
export type GetAdminCsvResult = NonNullable<Awaited<ReturnType<typeof getAdminCsv>>>
export type GetUserCountResult = NonNullable<Awaited<ReturnType<typeof getUserCount>>>
